import React from 'react';

import Text from '@sats-group/ui-lib/react/text/text';

import ContentContainer from '../../components/content-container/content-container';
import Logo from '../../components/logo/logo';
import type { NamedFC } from '../../types/named-fc.types';

import type { Maintenance as Props } from './maintenance.props';

const Maintenance: NamedFC<Props> = ({ logo, text }) => {
  return (
    <div className="maintenance">
      <ContentContainer>
        <div className="maintenance__content">
          <div className="maintenance__logo">
            <Logo {...logo} />
          </div>
          <Text elementName="h1" size={Text.sizes.large}>
            {text}
          </Text>
        </div>
      </ContentContainer>
    </div>
  );
};

Maintenance.displayName = 'Maintenance';

export default Maintenance;
